function AdminService($q, AppSettings, AuthService, CommonService) {
  'ngInject';

  const service = {};

  // 구단주/단장 팀 지정
  service.setTeam = function (params) {
    const url = AppSettings.apiUrl.restRoot + 'admin/set_team';
    return CommonService.post(url, params);
  };

  // 메뉴 목록 조회
  service.menus = function(param) {
    const url = AppSettings.apiUrl.restRoot + 'admin/menus';

    return CommonService.post(url, param);
  };

  // 메뉴 추가 or 변경
  service.addMenu = function(param) {
    const url = AppSettings.apiUrl.restRoot + 'admin/add_menu';

    return CommonService.post(url, param);
  };

  // 메뉴 삭제
  service.removeMenu = function(param) {
    const url = AppSettings.apiUrl.restRoot + 'admin/remove_menu';

    return CommonService.post(url, param);
  };

  // 선수 목록 조회
  service.userList = function(param) {
    const url = AppSettings.apiUrl.restRoot + 'admin/user_list';

    return CommonService.post(url, param);
  };

  //역할 목록 조회
  service.getRoles = function(param) {
    const url = AppSettings.apiUrl.restRoot + 'admin/roles';

    return CommonService.post(url, param);
  };

  //팀별 데이터 목록
  service.getApiList = function(param) {
    const url = AppSettings.apiUrl.restRoot + 'admin/api_list';

    return CommonService.post(url, param);
  };

  // 시스템 상태 조회
  service.getStatus = function(param) {
    const url = AppSettings.apiUrl.restRoot + 'admin/status';

    return CommonService.post(url, param);
  };

  // 관리자 설정
  service.getMain = function(param) {
    const url = AppSettings.apiUrl.restRoot + 'admin/main';

    return CommonService.post(url, param);
  };

  // 디바이스 검색
  service.getDeviceList = function(param) {
    const url = AppSettings.apiUrl.restRoot + 'admin/device_list';

    return CommonService.post(url, param);
  };

  // 디바이스 추가
  service.addDevice = function(param) {
    const url = AppSettings.apiUrl.restRoot + 'admin/add_device';

    return CommonService.post(url, param);
  };

  // 디바이스 삭제
  service.removeDevice = function(param) {
    const url = AppSettings.apiUrl.restRoot + 'admin/remove_device';

    return CommonService.post(url, param);
  };

  // 디바이스 속성 변경
  service.setDevice = function(param) {
    const url = AppSettings.apiUrl.restRoot + 'admin/set_device';

    return CommonService.post(url, param);
  };

  // 펌웨어 목록 조회
  service.getFirmwareList = function(param) {
    const url = AppSettings.apiUrl.restRoot + 'admin/firmware_list';

    return CommonService.post(url, param);
  };

  // 펌웨어 저장
  service.applyFirmware = function(param){
    const url = AppSettings.apiUrl.restRoot + 'admin/add_firmware';

    return CommonService.post(url, param);
  };

  // 펌웨어 추가
  service.addFirmware = function(file,param) {

    var apiUrl;
    const url = AppSettings.apiUrl.restRoot + 'admin/add_firmware';

    if (process.env.NODE_ENV === 'production') {
      apiUrl = AppSettings.apiUrl.production;
    } else {
      apiUrl = AppSettings.apiUrl.development;
    }

    param['upload[datafile]'] = file;
    console.log(param);

    return new Promise(function(resolve){
      Upload.upload({
        url: apiUrl + '?url=' + url,
        data: param
      }).then(function (resp) {
        resolve(resp.data);
      });
    });

  };

  //펌웨어삭제
  service.removeFirmware = function(param) {
    const url = AppSettings.apiUrl.restRoot + 'admin/remove_firmware';

    return CommonService.post(url, param);
  };

  //데이터 제공/제외
  service.manageApi = function(param) {
    const url = AppSettings.apiUrl.restRoot + 'admin/manage_api';

    return CommonService.post(url, param);
  };

  //데이터 제공/제외
  service.manageTeam = function(param) {
    const url = AppSettings.apiUrl.restRoot + 'admin/manage_team';

    return CommonService.post(url, param);
  };

  // 국가목록 조회
  service.getCountries = function(param){
    const url = AppSettings.apiUrl.restRoot + 'user/countries';

    return CommonService.post(url, param);
  };

  // 메뉴 할당
  service.assignMenu = function(param){
    const url = AppSettings.apiUrl.restRoot + 'admin/assign_menu';

    return CommonService.post(url, param);
  };

  // 메뉴 할당 취소
  service.revokeMenu = function(param){
    const url = AppSettings.apiUrl.restRoot + 'admin/revoke_menu';

    return CommonService.post(url, param);
  };

  // 역할 할당
  service.assignRole = function(param){
    const url = AppSettings.apiUrl.restRoot + 'admin/assign_role';

    return CommonService.post(url, param);
  };

  // 역할 할당 취소
  service.revokeRole = function(param){
    const url = AppSettings.apiUrl.restRoot + 'admin/revoke_role';

    return CommonService.post(url, param);
  };

  // 사용자 목록 - 관리자 설정
  service.getUsers = function(param){
    const url = AppSettings.apiUrl.restRoot + 'admin/users';

    return CommonService.post(url, param);
  };

  // 사용자 승인,거절
  service.manageUser = function(param){
    const url = AppSettings.apiUrl.restRoot + 'admin/manage_user';

    return CommonService.post(url, param);
  };

  // 팀 목록
  service.getTeams = function(params) {
    const url = AppSettings.apiUrl.restRoot + 'user/teams';

    return CommonService.post(url, params);
  };

  // 포지션 목록
  service.getPositions = function(params) {
    const url = AppSettings.apiUrl.restRoot + 'user/positions';

    return CommonService.post(url, params);
  };

  // 신분 목록
  service.getUserTypes = function(params) {
    const url = AppSettings.apiUrl.restRoot + 'user/user_types';

    return CommonService.post(url, params);
  };

  // 선수 추가
  service.addPlayer = function(params) {
    const url = AppSettings.apiUrl.restRoot + 'user/join';

    return CommonService.post(url, params);
  };

  // 선수 수정
  service.editPlayer = function(params) {
    const url = AppSettings.apiUrl.restRoot + 'user/modify';

    return CommonService.post(url, params);
  };

  // 팀목록 조회
  service.searchTeams = function(params) {
    const url = AppSettings.apiUrl.restRoot + 'admin/team_list';

    return CommonService.post(url, params);
  };
















  
    return service;
  }
  
  export default {
    name: 'AdminService',
    fn: AdminService
  };
  